import React from 'react'
import './About.css'
import { Link } from 'react-router-dom'
import aboutimage from '../images/ABOUT-IMAGE.jpeg'
const About = () => {
  return (
    <section className='container'>
        <div className='aboutcontainer'> 
        <article className='aboutleft'>
            <h1 className='abouttext'>ABOUT US</h1>
            <p>EAEC offers Property Valuation, commercial brokerage, retail leasing and management, Property development Finance brokerage, research, advisory, asset management, project management, facilities management, and other corporate real estate services in Nigeria​ </p>
            <p>EAEC is registered with the Estate Surveyors and Valuers Registration Board of Nigeria (ESVARBON) and enjoys association with the Nigerian Institution of Estate Surveyors and Valuers (NIESV).</p>
           <div className='aboutbtncon'><button className="buttoncontainer"><Link to='/about'>Read more</Link></button></div>
           
        </article>
        <article className='about-img-conatiner'>
            <img className='about-img' src={aboutimage} alt="real estate nigeria" />
        </article>
       

    </div>
    </section>
    
  )
}

export default About